<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 监测数据查询
        </span>
        <div class="normalNav zaddBtn" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="PurpleSmBtn" @click="deviceFocus">导出</button>
          <button class="GreenSmBtn" @click="downDataReportSheet">数据报表</button>
        </div>
        <div class="searchForm1 historForm">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="开始时间" prop="startTime">
                <el-date-picker v-model="formData.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker v-model="formData.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="监测类型">
                <el-select placeholder="请选择监测类型" v-model="formData.systemId" @change="bindChange">
                  <el-option v-for="item in applyArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select placeholder="请选择设备类型" v-model="formData.deviceType">
                  <el-option v-for="item in deviceTypeArr" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="项目名称">
                <el-select placeholder="请选择项目名称" v-model="formData.parentRegionId">
                  <el-option v-for="item in projectNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="formData.deviceName"></el-input>
              </el-form-item>
              <!-- <el-form-item label="设备编码">
                <el-input v-model="formData.deviceId"></el-input>
              </el-form-item> -->
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <easyTable apiUrl="extra/houseSensor" :parent="self" :config="config" :other="other" ref="table_jsgl">
            <template slot="last">
               <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="dataDetail(scope.$index, scope.row)"
                  >详情</el-link
                  >                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
      </el-tab-pane>S
    </el-tabs>
    <mountPoint :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible=false" @regionTreeData="selRegionData"></mountPoint>
    <el-dialog class="editDialog dataTj" title="导出" :visible.sync="editDialogVisible" @close="closeDownDia" width="40%">
      <el-form :model="dialogFormData" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker v-model="dialogFormData.startTime" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="dialogFormData.endTime" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目名称" prop="parentRegionId">
          <el-select placeholder="请选择项目名称" v-model="dialogFormData.parentRegionId" clearable>
            <el-option v-for="item in projectNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelButton" @click="closeDownDia">取消</el-button>
<!--        <downloadBtn :url="'extra/houseSensor/export/excel'" :params="dialogFormData" method="get" :beforeCallBack="checkForm">导出</downloadBtn>-->
        <el-button class="PurpleSmBtn" @click="checkForm">导出</el-button>
      </div>
    </el-dialog>
    <el-dialog class="editDialog dataTj" title="数据报表" :visible.sync="dataReportSheet" @close="closeDownDataSheet" width="40%">
      <el-form :model="dataSheetForm" :rules="rules2" label-width="100px">
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker disabled v-model="diagLog2startTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker @change="changeEndTime" v-model="dataSheetForm.endTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目名称" prop="projectId">
          <el-select placeholder="请选择项目名称" v-model="dataSheetForm.projectId" clearable>
            <el-option v-for="item in projectNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板名称" prop="flag">
          <el-select placeholder="请选择模板名称" v-model="dataSheetForm.flag" clearable>
            <el-option label="省人大" value="shengRenDaExcel"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelButton" @click="closeDownDataSheet">取消</el-button>
        <downloadBtn :url="'extra/houseSensor/export/dataReport'" :params="dataSheetForm" method="post" :beforeCallBack="checkForm2" title="下载"></downloadBtn>
      </div>
    </el-dialog>
    <el-dialog
      class="editDialog"
      :visible.sync="displayForm"
      :title="title"
      :close-on-click-modal="false"
    >
      <el-form :model="detail" >

        <el-form-item label="项目名称">
          <el-input
            v-model="detail.projectName"
          ></el-input>
        </el-form-item>
        <el-form-item label="区域名称">
          <el-input
            v-model="detail.region"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备网关">
          <el-input
            v-model="detail.gatewayId"
          ></el-input>
        </el-form-item>
        <el-form-item label="监测类型">
          <el-input
            v-model="detail.systemName"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备类型名称">
          <el-input
            v-model="detail.deviceTypeName"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input
            v-model="detail.deviceName"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备编码">
          <el-input
            v-model="detail.deviceId"
          ></el-input>
        </el-form-item>
        <el-form-item label="监测数据项">
          <el-input
            v-model="detail.dataFlowName"
          ></el-input>
        </el-form-item>
        <el-form-item label="上报功能码">
          <el-input
            v-model="detail.functionCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备状态">
          <el-input
            v-model="detail.deviceStatus"
          ></el-input>
        </el-form-item>
        <el-form-item label="初始值">
          <el-input
            v-model="detail.initialValue"
          ></el-input>
        </el-form-item>
        <el-form-item label="相对初始值">
          <el-input
            v-model="detail.relativeInitialValue"
          ></el-input>
        </el-form-item>
        <el-form-item label="实时值">
          <el-input
            v-model="detail.dataFlowData"
          ></el-input>
        </el-form-item>
        <el-form-item label="差值">
          <el-input
            v-model="detail.difference"
          ></el-input>
        </el-form-item>
        <el-form-item label="告警状态">
          <el-input
            v-model="detail.alarmStatusName"
          ></el-input>
        </el-form-item>
        <el-form-item label="报警数量">
          <el-input
            v-model="detail.alarmNum"
          ></el-input>
        </el-form-item>
        <el-form-item label="处置情况">
          <el-input
            v-model="detail.handleSituation"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注1">
          <el-input
            v-model="detail.remark1"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注2">
          <el-input
            v-model="detail.remark2"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注3">
          <el-input
            v-model="detail.remark3"
          ></el-input>
        </el-form-item>
        <el-form-item label="监测时间">
          <el-input
            v-model="detail.createTime"
          ></el-input>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
export default {
  data() {
    return {
      items: [],
      formData: {
        startTime: "",
        endTime: "",
        systemId: "",
        deviceType: "",
        deviceName: "",
        areaName: "",
        areaId: "",
        dataflowFlag: "",
        dataflowName: "",
        deviceId: "",
      },
      dialogFormData:{
        startTime:"",
        endTime:"",
        parentRegionId:""
      },
      //数据报表
      dataSheetForm:{
        endTime:"",
        projectId:"",
        flag: "",
      },
      diagLog2startTime:"",
      rules: {
        startTime: [
          { required: true, message: '请输入开始时间' }
        ],
        endTime: [
          { required: true, message: '请输入结束时间' }
        ],
        parentRegionId: [
          { required: true, message: '请输入项目名称' }
        ]
      },
      rules2: {
        endTime: [
          { required: true, message: '请选择结束时间' }
        ],
        projectId: [
          { required: true, message: '请选择项目名称' }
        ],
        flag: [
          { required: true, message: '请选择模板' }
        ]
      },
      valueFormat: "yyyy-MM-dd ",
      form_jsgl: {},
      applyArr: [],
      deviceTypeArr: [],
      treeData: [],
      //区域树是否显示
      areaTreeVisible: false,
      //区域树模式选择
      areaTreeMode: true,
      editDialogVisible: false,
      dataReportSheet: false,
      tableData: [],
      configArr: [
        {
          prop: "name",
          label: "名称",
        },
      ],
      changeDevice: [],
      key: "",
      title: "",
      tabName: "jsgl",
      showTable: true,
      other: {},
      planArr: [],
      testData: [],
      projectNameList:[],
      displayForm:false,
      detail:{
        "createTime":"",
        "functionCode":"",
        "projectName":"",
        "region":"",
        "gatewayId":"",
        "systemName":"",
        "deviceTypeName":"",
        "deviceName":"",
        "deviceId":"",
        "dataFlowName":"",
        "deviceStatus":"",
        "initialValue":"",
        "relativeInitialValue":"",
        "dataFlowData":"",
        "difference":"",
        "alarmStatusName":"",
        "alarmNum":"",
        "handleSituation":"",
        "remark1":"",
        "remark2":"",
        "remark3":""
      }
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        // {
        //   prop: "appName",
        //   label: "应用名称",
        // },
        // {
        //   prop: "typeName",
        //   label: "设备类型",
        // },
        {
          prop: "projectName",
          label: "项目名称",
        },
        // {
        //   prop: "deviceAreaname",
        //   label: "设备所在位置",
        // },
        {
          prop: "systemName",
          label: "监测类型",
        },
        {
          prop: "deviceName",
          label: "设备名称",
        },
        {
          prop: "dataFlowName",
          label: "监测数据项",
        },
        {
          prop: "deviceStatus",
          label: "设备状态",
        },
        {
          prop: "createTime",
          label: "监测时间",
        },
        {
          prop: "initialValue",
          label: "初始值",
        },
        {
          prop: "relativeInitialValue",
          label: "相对初始值",
        },
        {
          prop: "dataFlowData",
          label: "实时值",
        },
        {
          prop: "difference",
          label: "差值",
        },
        {
          prop: "alarmNum",
          label: "报警数量",
        }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    easyTable: () => import("public/easyTable"),
    searchForm: () => import("public/searchForm"),
    mountPoint: () => import("public/mountPoint"),
    downloadBtn:() => import('public/download'),
},
  mounted() {
    this.getApply();
    this.getTree();
    this.getProjectList();
  },
  methods: {
    changeEndTime() {
      if (this.dataSheetForm.endTime.substring(8,10) === '01'){
        this.$message.warning("请每月一号之后导出！");
      }
      this.diagLog2startTime = new Date(this.dataSheetForm.endTime.substring(0,8) + "01 00:00:00");
    },
    changeEndDate() {
      this.dialogFormData.endTime = new Date(this.dialogFormData.endTime.substring(0,11) + "23:59:59");
    },
    checkForm() {
        // 判断时间
        let t1 = new Date(this.dialogFormData.startTime.substring(5, 7) + ' ' + this.dialogFormData.startTime.substring(8, 10) + ',' + this.dialogFormData.startTime.substring(0, 4) + ' ' + this.dialogFormData.startTime.substring(11))
        let t2 = new Date(this.dialogFormData.endTime.substring(5, 7) + ' ' + this.dialogFormData.endTime.substring(8, 10) + ',' + this.dialogFormData.endTime.substring(0, 4) + ' ' + this.dialogFormData.endTime.substring(11))
        if (t2.getTime() < t1.getTime()) {
          this.$message.warning('开始时间不能大于结束时间！')
          return;
        } else if ((t2.getTime() - t1.getTime()) > 7 * 24 * 60 * 60 * 1000) {
          this.$message.warning('选择时间段不能超过一周！')
          return;
        }else if (this.dialogFormData.startTime.substring(5, 7) != this.dialogFormData.endTime.substring(5, 7)) {
          this.$message.warning('选择时间段不能超过一个自然月！')
          return;
        }
      this.editDialogVisible = false;
      this.$message.success('导出中，请稍等！')
      this.$axios({
        url: process.env.API_HOST + "extra/houseSensor/export/excel",
        method: "post",
        responseType: "blob",
        params: {
          startTime:this.dialogFormData.startTime+' 00:00:00',
          endTime:this.dialogFormData.endTime+' 23:59:59',
          parentRegionId:this.dialogFormData.parentRegionId,
          companyId:localStorage.getItem("companyId")
        },
        headers: {
          authUserId: localStorage.getItem("authUserId")
        }
      }).then((res) => {
        const a = document.createElement("a");
        // const u = process.env.API_HOST + res.data;
        const u = window.URL.createObjectURL(new Blob([res.data]));
        a.href = u;
        a.style.display = "none";
        a.setAttribute('download', '房屋监测数据.xls');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
      this.dialogFormData.startTime = "";
      this.dialogFormData.endTime = "";
      this.dialogFormData.parentRegionId = "";
    },
    checkForm2() {
      return new Promise((resolve, reject) => {
        if (this.dataSheetForm.endTime === '' || this.dataSheetForm.projectId === '' || this.dataSheetForm.flag === ''){
          this.$message.warning("请选择下载条件!");
          resolve(false);
        }
        resolve(true);
      })
    },
    closeDownDia(){
      this.editDialogVisible = false;
      this.dialogFormData.startTime = "";
      this.dialogFormData.endTime = "";
      this.dialogFormData.parentRegionId = "";
    },
    closeDownDataSheet(){
      this.dataReportSheet = false;
      this.diagLog2startTime = "";
      this.dataSheetForm.endTime = "";
      this.dataSheetForm.parentRegionId = "";
      this.dataSheetForm.flag = "";
    },
    dataDetail(index,row){
      this.displayForm = true;
      this.detail.createTime=row.createTime;
      this.detail.functionCode=row.functionCode;
      this.detail.projectName=row.projectName;
      this.detail.region=row.region;
      this.detail.gatewayId=row.gatewayId;
      this.detail.systemName=row.systemName;
      this.detail.deviceTypeName=row.deviceTypeName;
      this.detail.deviceName=row.deviceName;
      this.detail.deviceId=row.deviceId;
      this.detail.dataFlowName=row.dataFlowName;
      this.detail.deviceStatus=row.deviceStatus;
      this.detail.initialValue=row.initialValue;
      this.detail.relativeInitialValue=row.relativeInitialValue;
      this.detail.dataFlowData=row.dataFlowData;
      this.detail.difference=row.difference;
      this.detail.alarmStatusName=row.alarmStatusName;
      this.detail.alarmNum=row.alarmNum;
      this.detail.handleSituation=row.handleSituation;
      this.detail.remark1=row.remark1;
      this.detail.remark2=row.remark2;
      this.detail.remark3=row.remark3;
    },
    getApply() {
      this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId?compayId=".concat(
          localStorage.getItem("companyId")
        )
      ).then(res => {
        this.applyArr = res.data.data;
      });
    },
    getProjectList(){
      this.$axiosget(
        "operation/area/selectByLevel?level=2"
      ).then(res => {
        this.projectNameList = res.data.data;
      });
    },
    bindChange() {
      this.formData.deviceId = "";
      if (this.formData.systemId != "") {
        this.$axiosget(
          "manager/operatingSystemApi/getDeviceTypeByOperatingId?id=".concat(
            this.formData.systemId
          )
        ).then(res => {
          this.deviceTypeArr = res.data.data;
          this.formData.deviceType = "";
          this.formData.dataflowFlag = "";
          this.formData.dataflowName = "";
        });
      }
    },
    // 获取数据流
    bindType() {
      if (this.formData.deviceType != "") {
        this.$axiosget(
          "manager/dataFlow/queryAll?pageNum=1&pageSize=10000&device_type_id=".concat(
            this.formData.deviceType
          )
        ).then(res => {
          this.tableData = res.data.data.list;
          this.formData.dataflowFlag = "";
          this.formData.dataflowName = "";
        });
      }
    },
    getTree() {
      this.$axiosget(
        "operation/area/selectByUserId?userId=".concat(
          this.$store.state.user.id
        )
      ).then(res => {
        this.treeData = res.data.data;
      });
    },
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      this.formData.areaId = a.id;
      this.formData.areaName = a.name;
    },
    checkSelect(data) {
      if (data.length > 1) {
        this.$refs.Table.clearSelection();
        this.$refs.Table.toggleRowSelection(data.pop());
      } else if (data.length == 1) {
        this.changeDevice = data[0];
        // this.formData.dataflowFlag = data[0].data_flag;
        // this.formData.dataflowName = data[0].name;
        this.formData.dataFlag = data[0].name;

      }
    },
    deviceFocus() {
      this.editDialogVisible = true;
    },
    downDataReportSheet() {
      this.dataReportSheet = true;
    },
    reset() {
      this.formData = {
        startTime: "",
        endTime: "",
        systemId: "",
        deviceType: "",
        deviceName: "",
        areaName: "",
        areaId: "",
        dataflowFlag: "",
        deviceId: "",
        dataflowName: "",
      };
      this.deviceTypeArr = [];
    },
    subSeefrom() {
      if (this.formData.startTime.substring(0,7) != this.formData.endTime.substring(0,7)){
        this.$message.warning('选择时间段不能超过一个月！');
        return;
      }
      this.other = this.formData;
      this.$nextTick(this.$refs.table_jsgl.getData);
    },
  },
};
</script>
<style lang='less' scoped>
.dataTj .el-checkbox__inner {
  background-color: #5889e4;
  border: 1px solid #5889e4;
}
.dataTj {
  thead .el-table-column--selection .cell {
    display: none;
  }
}
.historForm .el-form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
  .el-date-editor {
    width: calc(100%);
  }
  .el-range-input {
    background: #2e3657;
  }
}

.content /deep/ .editDialog .el-form .el-input__inner, .content .editDialog .el-form textarea {
  border-radius: 0;
  width: 310px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/deviceData/monitorData.vue